export enum ToasterSeverities {
  Success = "success",
  Info = "info",
  Warn = "warn",
  Error = "error",
}
